import { faInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Style.css';

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ModalWrapper from '../../../../../shared/modal/ModalWrapper';
import { EmptyGraph } from '../emptyGraph/EmptyGraph';

function BarChart(props) {
  const { t } = useTranslation();
  const [values, setDataValues] = useState(props.data);

  const { unit } = props;
  const lowerVal = 0;

  const [barsList, setBarsList] = useState([]);

  useEffect(() => {
    const newvalues = props.data;

    const valuearray = [];
    newvalues.forEach((item) => {
      valuearray.push(item.value);
    });
    const upperVal = props.max || Math.round(Math.max(...valuearray));

    let step1 = Math.ceil((upperVal - lowerVal) / 4);
    let rows = 5;
    if (props.max === 10) {
      step1 = Math.ceil((props.max - lowerVal) / 5);
      rows = 6;
    }
    if (step1 < 1) {
      step1 = 1;
    }
    const step = step1;

    // buildRows();
    const bars = [];
    let p = 0;
    for (let i = lowerVal; i < rows; i++) {
      // upperval
      // alert(i);
      bars[i] = { key: i, value: p }; // i
      p += step; // -1
    }
    setBarsList(bars.reverse());

    // setColumnHeights();
    let newHeight = '';
    // var range = upperVal - lowerVal;
    const range = props.max || step * (rows - 1);

    for (let n = 0; n < newvalues.length; n++) {
      newHeight = Math.round((100 / range) * (newvalues[n].value - lowerVal));
      // newHeight = (100 / range) * (values[n].value - lowerVal);
      if (newHeight === 0) {
        newHeight = 1;
      }
      newvalues[n].height = `${newHeight}%`;
    }

    setDataValues(newvalues);
  }, [props.data]);

  if (props.disabled) {
    return <EmptyGraph title={props.title} />;
  }

  return (
    <div
      className={`${props.width ? `square ${props.width}` : 'square'} ${
        props.disabled ? 'disabled' : ''
      }`}
    >
      <div className={`square_content bar_chart_container ${props.disabled ? 'disabled' : ''}`}>
        {props.modalText && !props.disabled && (
          <ModalWrapper modalText={props.modalText} onOpenModal={props.onOpenModal}>
            <FontAwesomeIcon icon={faInfo} className="icon info_icon" />
          </ModalWrapper>
        )}
        {props.disabled && <FontAwesomeIcon icon={faInfo} className="icon info_icon" />}
        {props.title ? <h3>{props.title}</h3> : ''}
        {props.subTitle ? <span className="subtitle">{props.subTitle}</span> : ''}
        {props.preText && <div className="subtitle">{props.preText}</div>}
        {props.disabled && <div className="graph_disabled_text">{t('BC014')}</div>}
        <div className={`${props.yaxis ? 'bar-chart yaxis' : 'bar-chart'}`}>
          {props.yaxis && <div className="yaxis">{props.yaxis}</div>}
          {barsList && values && (
            <>
              {barsList.map((item) => {
                return (
                  <div className="row" key={item.key}>
                    <span>
                      {item.value} {unit}
                    </span>
                  </div>
                );
              })}
              <div className="column-container">
                {values.map((item, index) => {
                  return (
                    <div
                      className={`${item.date === 'DD MM' ? 'blank column' : 'column'}`}
                      style={{ height: item.height }}
                      key={item.date + index}
                    >
                      <span>{item.date}</span>
                      {!props.disabled && (
                        <span className="hover_box">
                          {item.value}
                          {unit}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default BarChart;
